var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubbleSlide6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,16v8h-8c-2.955,0-5.535-1.615-6.92-4.004,.382-.003,.759-.025,1.131-.066,1.261,1.851,3.385,3.07,5.789,3.07h7v-7c0-2.404-1.219-4.528-3.07-5.789,.041-.372,.064-.749,.066-1.131,2.389,1.385,4.004,3.965,4.004,6.92Zm-15,2H0V9C0,4.037,4.038,0,9,0s9,4.037,9,9-4.038,9-9,9Zm8-9c0-4.411-3.589-8-8-8S1,4.589,1,9v8H9c4.411,0,8-3.589,8-8Zm-8-1c-.552,0-1,.448-1,1s.448,1,1,1,1-.448,1-1-.448-1-1-1Zm-4,0c-.552,0-1,.448-1,1s.448,1,1,1,1-.448,1-1-.448-1-1-1Zm8,0c-.552,0-1,.448-1,1s.448,1,1,1,1-.448,1-1-.448-1-1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleSlide6);
export default __webpack_public_path__ + "static/media/bubble-slide-6.a7297b7919c069f6756548b702bf73e1.svg";
export { ForwardRef as ReactComponent };